import React from 'react';
import { useDispatch } from 'react-redux';
import { Container, Divider, Typography, Box } from '@mui/material';
import { styled } from '@mui/material/styles';
import OnboardingUserForm from './OnboardingUserForm';
import GoogleLoginButton from '../GoogleLogin';
import { registerAppUser } from '../../../actions/onboarding-actions';
import { LOGIN_URL } from '../../../utils/redirect-const';
import { useNavigate, Link } from 'react-router-dom';

const StyledContainer = styled(Container)(({ theme }) => ({
  maxWidth: 'sm',
  marginTop: theme.spacing(4),
  padding: theme.spacing(2),
  borderRadius: theme.shape.borderRadius,
  [theme.breakpoints.down('sm')]: {
    padding: theme.spacing(1),
  },
}));

const BottomActionWrapper = styled(Box)(({ theme }) => ({
  marginTop: theme.spacing(3),
  textAlign: 'center',
}));

const OrDivider = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  margin: theme.spacing(2, 0),
  '&::before, &::after': {
    content: '""',
    flex: 1,
    borderBottom: `1px solid ${theme.palette.divider}`,
  },
  '&::before': {
    marginRight: theme.spacing(2),
  },
  '&::after': {
    marginLeft: theme.spacing(2),
  },
}));

const Onboarding = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleRegister = (formValues, form) => {
    dispatch(registerAppUser(formValues, form, navigate));
  };

  return (
    <StyledContainer>
      <Typography variant="h4" align="center" gutterBottom>
        Rejestracja
      </Typography>

      <Box sx={{ mb: 2 }}>
        <GoogleLoginButton />
      </Box>

      <OrDivider>
        <Typography variant="body2" color="text.secondary">
          lub
        </Typography>
      </OrDivider>

      <OnboardingUserForm onSubmit={handleRegister} />

      <Divider variant="middle" sx={{ marginY: 3 }} />

      <BottomActionWrapper>
        Masz już konto?{' '}
        <Link to={LOGIN_URL} underline="none" variant="body2">
          Zaloguj się
        </Link>
      </BottomActionWrapper>
    </StyledContainer>
  );
};

export default Onboarding;